// extracted by mini-css-extract-plugin
module.exports = {"container-mobile":"WidescreenLock_container-mobile__3pXVO","widescreen-lock":"WidescreenLock_widescreen-lock__2h9j_","giraIcon":"WidescreenLock_giraIcon__1tzvB"};